import { Color } from '@billy/design-system'
import { css } from '@emotion/core'
import { transparentize } from 'polished'

export const getStickyCellStyles = () => {
  return css`
    &:first-of-type {
      position: sticky;
      left: 0;
      background-color: ${Color.White};
      min-width: 320px;
      max-width: 320px;
      z-index: 1;

      /* Add shadow effect */
      &::before {
        content: '';
        position: absolute;
        top: 0;
        right: -15px;
        width: 15px;
        height: 100%;
        background: linear-gradient(to right, ${transparentize(0.3, Color.Grey200)}, transparent);
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.2s ease;
      }
    }
  `
}
